import { render, staticRenderFns } from "./ButtonContainer.vue?vue&type=template&id=50d6f0ec&scoped=true"
var script = {}
import style0 from "./ButtonContainer.vue?vue&type=style&index=0&id=50d6f0ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d6f0ec",
  null
  
)

export default component.exports